<div class="preview">
  @for (file of items; track file) {
    <div class="w-100" (click)="cardClick.emit(file[nameProperty])">
      <div class="file">
        <div class="file__preview" [ngClass]="{ 'file__preview--centered': !isImageFile(file) }">
          @if (isImageFile(file)) {
            @if (showThumbnail) {
              <img [alt]="file[nameProperty]" [src]="imagePathProperty ? file[imagePathProperty] : (file | fileUrl)" />
            }
          }
          @if (!isImageFile(file)) {
            <i class="far fa-file"></i>
          }
        </div>
        @if (showFilename) {
          <p class="file__name" (click)="fileService.downloadFile(file)">
            {{ file[nameProperty] || file.filename }}
          </p>
        }
        @if (deletable) {
          <i
            class="fas fa-trash-alt file--remove no-print"
            [title]="'button.delete' | translate"
            (click)="handleRemoveIconClick($event, file)">
          </i>
        }
      </div>
    </div>
  }

  @if (showLoader) {
    <div class="spinner-wrapper">
      <i class="fas fa-spinner-third"></i>
    </div>
  }
</div>
